module.exports = __webpack_public_path__ + "img/logo-doctoralia-turquoise-rgb.30197424.png";